import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

// Components
import BaseContentContainer from '../../components/base-content-container/base-content-container';
import ButtonsBar from '../../components/buttons-bar/buttons-bar';
import Empty from '../../components/empty/empty';
import ErrorComponent from '../../components/error/error';
import FeatureTitle from '../../components/feature-title/feature-title';
import List from '../../components/list/list';
import Loading from '../../components/loading/loading';
import SubmitButton from '../../components/submit-button/submit-button';

// Models
import {
  BaseContentContainerActionButtonPosition,
  BaseContentContainerFormat,
} from '../../models/base-content-container';

// Services
import NoticeBoardService from '../../services/notice-board-service';

const NoticeBoardList = () => {
  const noticeBoardService = new NoticeBoardService();

  const titles: ListContentTitle[] = [
    { text: 'Título' },
    { text: 'Turmas' },
    { text: 'Data', align: 'right' },
  ];

  const [error, setError] = useState(false);
  const [noticeBoardList, setNoticeBoardList] = useState<ListContent[]>(null);
  useEffect(() => {
    noticeBoardService
      .listNoticeBoards()
      .then((noticeBoardGroupList) => {
        const newNoticeBoardList = [];

        noticeBoardGroupList.forEach((noticeBoardGroup) => {
          const noticeBoardItem: ListContent = {
            linkTo: `/mural/${noticeBoardGroup.noticeBoardItem.id}`,
            data: [
              {
                text: noticeBoardGroup.noticeBoardItem.title,
                customStyle: { maxWidth: '250px' },
              },
              {
                text:
                  noticeBoardGroup.classrooms.length === 1
                    ? noticeBoardGroup.classrooms[0].name
                    : `${noticeBoardGroup.classrooms.length} turmas`,
              },
              {
                text: new Date(
                  noticeBoardGroup.noticeBoardItem.createdAtUtc
                ).toLocaleDateString('pt-br'),
                align: 'right',
              }
            ],
          };

          newNoticeBoardList.push(noticeBoardItem);
        });

        setNoticeBoardList(newNoticeBoardList);
      })
      .catch(() => setError(true));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (error) return <ErrorComponent type='contentFull' />;

  if (!noticeBoardList) return <Loading type='contentFull' />;

  return (
    <BaseContentContainer
      format={BaseContentContainerFormat.singleWithActionButtons}
      actionButtonPosition={BaseContentContainerActionButtonPosition.top}
    >
      <ButtonsBar pattern='firstSeparate'>
        <FeatureTitle title='mural' />
        <Link to='/mural/criar'>
          <SubmitButton value='criar novo mural' variant='primary' />
        </Link>
      </ButtonsBar>

      {noticeBoardList.length > 0 ? (
        <List titles={titles} contents={noticeBoardList} />
      ) : (
        <Empty />
      )}
    </BaseContentContainer>
  );
};

export default NoticeBoardList;
